import React from "react";

import { PaginatorTemplate } from "primereact/paginator";
import i18n from "i18n";

export const tablePaginator: PaginatorTemplate = {
    layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport",
    CurrentPageReport: (options) => {
        return (
            <div className="ml-10">
                {options.first} - {options.last} {i18n.t("of")} {options.totalRecords} {i18n.t("paginator>>results")}
            </div>
        );
    },
} as PaginatorTemplate;
